const moduleSelector = '[data-module="LazySliders"]';
import {
    filter,
    mergeMap
} from 'rxjs/operators';

import {
    hasImageToBeLoaded,
    loadImageLazy$,
} from '../helpers/DOMHelpers'
import { from } from 'rxjs';


export default class LazySliders {
    static setup(selector: string = moduleSelector): void {
        Array.from(document.querySelectorAll(selector)).filter((node: HTMLElement) => !node.dataset.moduleInitialized).forEach((element: HTMLElement) => {
            new LazySliders(element);
            element.dataset.moduleInitialized = 'true';
        });
    }

    constructor(public element?: HTMLElement) {
        let stage = document.querySelector('.cp-stage');
        if (!stage) {
            return;
        }
        stage.addEventListener('itemshow', (e) => {
            this.initLazySlider(<HTMLElement>e.target);
        })
    }

    private initLazySlider(target) {
        this.loadForActiveSlides(target)
        this.loadForNextSlide(target);
        this.loadForPrevSlide(target);
    }

    private loadForActiveSlides(activeSLide: HTMLElement) {
        this.loadSlideImg(activeSLide);
    }

    private loadForNextSlide(target) {
        var nextElement = target.nextElementSibling
        if (!nextElement) 
            return false;

        this.loadSlideImg(nextElement);

    }

    private loadForPrevSlide(target) {
        var prevElement = target.previousElementSibling
        if (!prevElement)
            return false;

        this.loadSlideImg(prevElement);
    }

    private loadSlideImg(targetSlide) {
        var images = this.getImages(targetSlide);
        from(images).pipe(
            filter(hasImageToBeLoaded),
            mergeMap(loadImageLazy$)
        ).subscribe();
    }

    private getImages(slide) {
        return <HTMLImageElement[]>Array.from(slide.querySelectorAll('source[data-srcset], img[data-src], img[data-src-set]'));
    }


}

new LazySliders.setup();